/**
 * GENERATED FILE — do not edit by hand.
 *
 * Rebuild with `npm --prefix web run words`; the generator, and the reasoning
 * behind which words land where, is in ../__tools/build-words.mjs.
 *
 * Derived from SCOWL (Spell Checker Oriented Word Lists) via the
 * `wordlist-english` package. SCOWL is Copyright 2000-2016 by Kevin Atkinson
 * and is used under its permissive licence, which asks that this notice travel
 * with the words:
 *
 *   Permission to use, copy, modify, distribute and sell these word lists, the
 *   associated scripts, the output created from the scripts, and its
 *   documentation for any purpose is hereby granted without fee, provided that
 *   the above copyright notice appears in all copies and that both that
 *   copyright notice and this permission notice appear in supporting
 *   documentation. Kevin Atkinson makes no representations about the
 *   suitability of this array for any purpose. It is provided "as is" without
 *   express or implied warranty.
 *
 * Stored as newline-joined strings rather than arrays of strings: same bytes on
 * the wire minus two quotes and a comma per word, and the only thing either one
 * is ever turned into is a Set.
 */

/** Words the game will pick as an answer: common enough to be findable. */
export const ANSWERS = `abide
abort
about
above
abuse
acorn
acted
actor
acute
adapt
added
admit
adopt
adult
after
again
agent
agony
agree
ahead
aided
aimed
alarm
album
alert
alias
alien
align
alike
alive
allow
alone
along
aloud
alpha
alter
amaze
amber
amend
ample
amuse
angel
anger
angle
angry
annoy
apart
apple
apply
arena
argue
arise
armed
arose
array
arrow
aside
asked
asset
atlas
audio
avoid
await
awake
award
aware
awful
axiom
badge
badly
baked
banal
based
basic
basis
batch
beach
beard
beast
began
begin
begun
being
below
bench
bible
bigot
birth
black
blade
blame
blank
blast
bless
blind
blink
bliss
block
blood
blown
blurb
board
bogus
bonus
boost
bored
borne
bound
brain
brake
brand
brass
brave
bread
break
breed
brick
brief
bring
broad
broke
brown
brush
build
built
bunch
burnt
burst
buyer
cable
cared
carry
cased
catch
cater
cause
cease
chain
chair
chalk
chaos
charm
chart
chase
cheap
cheat
check
cheek
cheer
chess
chest
chief
child
choir
chord
chose
chuck
chunk
cider
circa
cited
civil
claim
clash
class
clean
clear
click
cliff
climb
clock
clone
close
cloth
cloud
coach
coast
coded
colon
comic
comma
coped
cough
could
count
court
cover
crack
craft
cramp
crash
crass
crawl
crazy
cream
creed
creep
cried
crime
crisp
cross
crowd
crown
crude
cruel
crush
cubic
cured
curly
curry
curse
curve
cycle
cynic
daily
dance
dared
dated
datum
dealt
death
debug
decay
deity
delay
delta
dense
depth
deter
devil
diary
digit
dined
diner
dirty
disco
ditch
ditto
dived
dodge
dogma
doing
doubt
dozen
draft
drain
drama
drank
drawn
dread
dream
dress
dried
drift
drill
drink
drive
drove
drown
drunk
dummy
dusty
dying
eager
eagle
early
earth
eaten
eater
eight
elect
elite
embed
empty
ended
enemy
enjoy
enter
entry
equal
equip
erase
error
essay
ethic
event
every
exact
exist
extra
faced
faint
fairy
faith
false
fancy
farce
fatal
fault
fence
fetch
fever
fewer
field
fifth
fifty
fight
filed
final
fined
finer
fired
first
fiver
fixed
fizzy
flame
flash
fleet
flesh
flied
float
flood
floor
flour
flown
fluid
flush
flute
focus
force
forth
forty
forum
found
frame
frank
fraud
freak
freed
fresh
fried
front
frown
froze
fruit
fudge
fully
funny
furry
fussy
fuzzy
genre
ghost
giant
given
glass
glean
glory
glove
gnome
going
goody
grace
grade
grain
grand
grant
graph
grasp
grass
grave
great
greed
green
grief
grind
groan
gross
group
grown
guard
guess
guest
guide
guilt
habit
hairy
halve
handy
happy
hardy
harsh
hasty
hated
havoc
heard
heart
heavy
hello
hence
hided
hired
hobby
honey
hoped
horde
horse
hotel
house
human
hurry
ideal
idiom
idiot
image
imply
inane
incur
index
infer
inner
input
inter
irate
irony
issue
jelly
joint
joked
jolly
judge
juice
keyed
knife
knock
known
label
lager
large
laser
later
laugh
layer
leach
learn
least
leave
legal
lemon
level
libel
light
liked
limit
lined
lived
liver
lobby
local
lodge
logic
loose
lorry
lousy
loved
lover
lower
loyal
lucky
lunch
lying
lyric
magic
maize
major
maker
mania
march
marry
match
maybe
mayor
meant
media
mercy
merge
merit
merry
messy
metal
meter
metro
might
mimic
mined
minor
minus
mixed
model
money
month
moral
moron
motor
motto
mount
mouse
mouth
moved
movie
mummy
music
naive
naked
named
nasty
nerve
never
newer
newly
nicer
night
noble
noise
noisy
north
noted
novel
nurse
occur
ocean
oddly
offer
often
older
onion
opera
opted
optic
orbit
order
organ
other
ought
outer
owing
owned
owner
ozone
paged
paint
panel
panic
paper
parse
party
paste
patch
pause
payed
peace
pedal
pence
pends
penny
petty
phase
phone
photo
piano
piece
pilot
pinch
pitch
pizza
place
plain
plane
plant
plate
point
polar
posed
pound
power
press
price
pride
prime
print
prior
prize
prone
proof
prose
proud
prove
pulse
punch
pupil
purge
queen
query
quest
queue
quick
quiet
quite
quota
quote
rabid
raced
radar
radio
raise
range
rapid
rarer
rated
ratio
raved
razor
reach
react
ready
realm
refer
reign
relax
relay
renew
reply
reset
reuse
rhyme
right
rigid
risen
risky
rival
river
robot
roman
rough
round
route
royal
ruled
ruler
rural
rusty
sadly
safer
saint
sauce
saved
scale
scare
scarf
scene
scope
score
scrap
screw
sense
serve
seven
shade
shake
shaky
shall
shame
shape
share
sharp
sheep
sheer
sheet
shelf
shell
shift
shine
shiny
shirt
shock
shone
shook
shoot
short
shout
shove
shown
sided
sight
sigma
silly
since
sixth
sixty
sized
skill
skirt
skull
slang
slash
slave
sleep
slept
slice
slide
slope
small
smart
smash
smell
smile
smith
smoke
snack
snail
sneak
sniff
sober
solar
solid
solve
sorry
sound
south
space
spare
speak
speed
spell
spend
spent
spike
spill
spite
split
spoil
spoke
spoof
spool
sport
spout
spray
squad
stack
staff
stage
stair
stake
stale
stall
stamp
stand
stare
stark
start
state
steal
steam
steel
steep
steer
stick
stiff
still
stock
stole
stone
stood
store
storm
story
straw
stray
strip
stuck
study
stuff
stunt
style
sugar
suing
suite
sunny
super
swamp
swear
sweat
sweep
sweet
swept
swing
sword
swore
sworn
table
taken
taker
taste
teach
teeth
tempt
tense
tenth
terse
thank
theft
their
theme
there
these
thick
thief
thing
think
third
those
three
threw
throw
thumb
tiger
tight
timed
timer
tired
title
toast
today
token
tooth
topic
total
touch
tough
tower
trace
track
trade
trail
train
trash
tread
treat
trend
trial
tribe
trick
tried
troop
truck
truly
trunk
trust
truth
tuned
tutor
twice
twist
tying
typed
uncle
under
undid
unify
union
unite
unity
unset
until
upper
upset
urban
urged
usage
using
usual
utter
vague
valid
value
valve
venue
verse
vicar
video
vinyl
virus
visit
vital
vocal
voice
vomit
voted
voter
vouch
vowel
waded
waked
waste
watch
water
waved
weary
weigh
weird
whale
wheel
where
which
while
white
whole
whoop
whose
wider
width
wiped
wired
wiser
witch
witty
woken
woman
women
world
worry
worse
worst
worth
would
wound
wrath
wreck
wrist
write
wrong
wrote
yield
young
youth`;

/** Legal guesses that are not answers. The full guess list is these plus those. */
export const EXTRA = `aalii
abaca
aback
abaft
abase
abash
abate
abbey
abbot
abeam
abele
abets
abhor
abies
abler
abmho
abode
abohm
abuts
abuzz
abysm
abyss
acari
acerb
ached
aches
achoo
acids
acing
acini
acmes
acned
acred
acres
acrid
actin
adage
addax
adder
addle
adept
adieu
adits
adman
admen
admix
adobe
adore
adorn
adown
adust
adzes
aecia
aedes
aegis
aeons
aerie
affix
afire
afoot
afore
afoul
afrit
aftie
aftos
agama
agape
agate
agave
agger
aggie
aggro
agile
aging
agios
agist
agita
aglet
agley
aglow
agone
agora
aider
aides
ailed
aired
airts
aisle
aitch
akees
akene
alack
alary
alate
alder
aldol
aleph
algae
algal
algid
algin
algor
alibi
alkyd
alkyl
allay
alley
allot
alloy
allyl
aloes
aloft
aloha
aloin
aloof
altar
altos
alula
alums
amahs
amain
amass
ambit
amble
ambos
ambry
ament
amice
amide
amigo
amine
amino
amiss
amity
amnio
among
amour
amply
ancon
anear
anele
anent
angst
anile
anils
anima
anime
anion
anise
ankhs
ankle
ankus
annal
annas
annex
annul
anoas
anode
anole
anons
anted
antes
antic
antis
antre
antsy
anvil
aorta
apace
apeak
apery
aphid
aphis
apian
aping
apish
apnea
aport
appal
appel
apron
apses
apsis
apter
aptly
aquas
araks
arbor
arced
ardeb
ardor
areal
areas
areca
argal
argil
argol
argon
argot
arias
ariel
arils
armet
armor
aroid
aroma
arras
arris
arsed
arses
arsis
arson
artel
artsy
arums
arvos
ascot
ascus
asdic
ashed
ashen
ashes
asker
askew
aspen
asper
aspic
assai
assay
asses
aster
astir
atilt
atman
atoll
atoms
atomy
atone
atony
atria
atrip
attar
attic
audit
auger
aught
augur
aulic
aulos
aunts
aural
aurar
auras
auric
aurum
autos
auxin
avail
avast
avens
avers
avert
avian
avion
avows
awash
awing
awned
awoke
axial
axils
axing
axles
axons
ayahs
ayins
azide
azine
azoic
azole
azote
azoth
azure
baaed
babas
babel
babes
babul
baccy
backs
bacon
baels
bagel
baggy
bahts
bails
bairn
baits
baiza
baize
baker
bakes
balas
balds
baldy
baled
baler
bales
balks
balky
balls
bally
balms
balmy
balsa
bands
bandy
banes
bangs
banjo
banks
banns
barbs
barde
bards
bared
barer
bares
barfs
barge
baric
barks
barms
barmy
barns
baron
barre
barye
basal
baser
bases
basil
basin
basks
basso
baste
bated
bates
bathe
baths
batik
baton
batty
baulk
bawds
bawdy
bawls
bayed
bayou
bazar
beads
beady
beaks
beams
beamy
beano
beans
bears
beats
beaus
beaut
bebop
becks
bedel
bedew
bedim
beech
beefs
beefy
beeps
beers
beery
beets
befit
befog
begat
beget
begot
begum
beige
belay
belch
belga
belie
belle
bells
belly
belts
bemas
bends
bendy
benne
benny
bents
beret
bergs
berks
berms
berry
berth
beryl
beset
besom
besot
bests
betas
betel
beths
betta
bevel
bevvy
bezel
bhaji
bhang
bialy
bicep
biddy
bides
bidet
bield
biers
biffo
biffs
bifid
bight
bijou
biked
biker
bikes
bilbo
bilge
bilks
bills
billy
bimah
bimbo
binal
binds
bines
binge
bingo
biome
biota
biped
bipod
birch
birds
birls
birrs
bises
bison
bitch
biter
bites
bitts
bitty
blabs
blags
blahs
blain
bland
blare
blate
blats
blaze
bleak
blear
bleat
blebs
bleed
bleep
blend
blimp
bling
blini
blips
blitz
bloat
blobs
blocs
blogs
bloke
blond
bloom
bloop
blots
blows
blowy
blued
bluer
blues
bluet
bluey
bluff
blunt
blurs
blurt
blush
boars
boart
boast
boats
bobby
boded
bodes
bodge
boffo
bogan
bogey
boggy
bogie
bogle
boils
bolas
boles
bolls
bolos
bolts
bolus
bombe
bombs
bonce
bonds
boned
boner
bones
bongo
bongs
bonks
bonne
bonny
bonza
bonze
boobs
booby
booed
books
booms
boong
boons
boors
booth
boots
booty
booze
boozy
borak
borax
borer
bores
boric
boron
bosky
bosom
boson
bossy
botch
botel
bothy
bough
boule
bourg
bouse
bouts
bovid
bowed
bowel
bower
bowls
bowse
boxed
boxer
boxes
boyar
boyla
bozos
brace
brach
bract
brads
braes
brags
braid
brail
brant
brash
brats
bravo
brawl
brawn
braxy
brays
braze
bream
brede
brent
breve
brews
briar
bribe
bride
brier
brigs
brill
brims
brine
brink
briny
brisk
brits
broch
brock
broil
bronc
brood
brook
broom
brose
broth
brows
bruin
bruit
brume
brunt
brute
bubal
bubba
bucko
bucks
buddy
budge
bueno
buffo
buffs
buggy
bugle
buhls
bulbs
bulge
bulgy
bulks
bulky
bulla
bulls
bully
bumph
bumps
bumpy
bunco
bundy
bungs
bunks
bunny
bunts
buoys
buran
burbs
buret
burgh
burgs
burin
burka
burke
burls
burly
burns
burps
burqa
burro
burrs
burry
bursa
burse
busby
bused
buses
bushy
busks
busts
busty
butch
buteo
butte
butts
butty
butut
butyl
buxom
bwana
bylaw
byres
bytes
byway
cabal
cabby
caber
cabin
cabob
cacao
cache
cacti
cadet
cadge
cadre
caffs
caged
cager
cages
cagey
caird
cairn
caked
cakes
calks
calla
calls
calms
calve
calyx
camel
cameo
campo
camps
campy
canal
candy
caned
caner
canes
canna
canny
canoe
canon
canso
canst
canto
cants
canty
caped
caper
capes
capon
capos
caput
carat
carbs
cards
carer
cares
caret
cargo
carks
carny
carob
carol
carom
carpi
carps
carse
carte
carts
carve
cases
casks
caste
casts
catty
cauda
caulk
cauls
caved
caver
caves
cavie
cavil
cawed
cecal
cecum
cedar
ceded
ceder
cedes
cedis
ceiba
celeb
cella
cello
cells
celom
cense
cento
cents
ceorl
cered
ceres
ceria
ceric
ceros
certs
cesar
cesta
chafe
chaff
champ
chant
chape
chaps
chard
chare
charr
chars
chary
chasm
chats
chaws
cheep
chefs
chela
chemo
chert
chevy
chews
chewy
chiao
chick
chico
chide
chili
chill
chimb
chime
chimp
china
chine
ching
chink
chino
chins
chips
chirk
chirm
chirp
chirr
chits
chive
chivy
chock
chocs
choke
choli
chomp
chook
chops
chore
chows
chubs
chufa
chuff
chugs
chump
chums
churl
churn
churr
chute
chyle
chyme
ciaos
cigar
cilia
cimex
cinch
cirri
cisco
cites
civet
civic
clack
clamp
clams
clang
clank
clans
claps
claro
clary
clasp
clave
clavi
claws
clays
cleat
cleek
clefs
cleft
clepe
clerk
clews
clime
cline
cling
clink
clips
clits
cloak
clods
clogs
clomb
clomp
clonk
clops
clots
clout
clove
clown
cloys
clubs
cluck
clued
clues
clump
clung
clunk
coact
coals
coaly
coati
coats
cobia
coble
cobra
cocci
cocks
cocky
cocoa
cocos
codas
coder
codes
codex
codon
coeds
cogon
cohos
coifs
coign
coils
coins
coirs
coked
cokes
colas
colds
coles
coley
colic
colly
color
colts
colza
comas
combe
combo
combs
comer
comes
comet
comfy
compo
comps
conch
condo
coned
cones
conga
conic
conks
conns
conte
conto
cooed
cooee
cooks
cools
coomb
coons
coops
coots
copal
copay
coper
copes
copra
copse
coral
cords
cored
corer
cores
corgi
coria
corks
corky
corms
corns
cornu
corny
corps
corse
coset
costa
coste
costs
cotes
cotta
couch
coupe
coups
couth
coven
coves
covet
covey
covin
cowed
cower
cowls
coxae
coxed
coxes
coyer
coyly
coypu
cozen
craal
crabs
crags
crake
crams
crane
crank
crape
craps
crapy
crate
crave
craws
craze
creak
credo
creek
creel
crees
creme
crepe
crept
cress
crest
crews
cribs
crick
crier
cries
crimp
crine
croak
crock
crocs
croft
crone
cronk
crony
crook
croon
crops
crore
croup
crows
croze
cruck
cruet
crumb
crump
cruse
crust
crwth
crypt
cubby
cubeb
cubed
cuber
cubes
cubit
cuddy
cuffs
cuing
cukes
culch
culet
culex
culls
cully
culms
culpa
cults
cumin
cunts
cupel
cupid
cuppa
curbs
curch
curds
curdy
curer
cures
curet
curia
curie
curio
curls
curvy
cusec
cushy
cusks
cusps
cutch
cuter
cutey
cutie
cutin
cutis
cutty
cutup
cycad
cylix
cymae
cymar
cymas
cymes
cysts
cyton
czars
daces
dacha
dadas
daddy
daeva
daffy
dagos
dahls
dairy
daisy
dales
dally
daman
damar
dames
damns
damps
dandy
dangs
danio
darer
dares
daric
darky
darns
darts
dater
dates
daube
daubs
daunt
davit
dawns
dazed
dazes
deals
deans
dears
deary
debag
debar
debit
debts
debus
debut
decaf
decal
decks
decor
decoy
decry
dedal
deeds
deems
deeps
defer
defog
degas
deice
deify
deign
deism
deist
dekko
delft
delis
dells
delve
demit
demob
demon
demos
demur
denar
denim
dents
depot
derby
derma
derry
desex
desks
detox
deuce
dewan
dhobi
dhole
dhoti
dhows
dials
diazo
diced
dicer
dices
dicey
dicks
dicot
dicta
didst
diets
dight
diked
dikes
dildo
dills
dilly
dimer
dimes
dimly
dinar
dines
dinge
dingo
dings
dingy
dinky
dints
diode
dippy
dipso
direr
dirge
dirks
discs
dishy
disks
ditsy
ditty
divan
divas
diver
dives
divot
divvy
diwan
dixie
dizen
dizzy
dobby
dobla
dobra
dobro
docks
dodgy
dodos
doers
doffs
doges
doggo
doggy
dogie
doily
dolce
doled
doles
dolls
dolly
dolor
dolts
domed
domes
donas
donee
donga
dongs
donna
donor
dooms
doona
doors
doozy
doped
doper
dopes
dopey
dorks
dorky
dorms
dorty
dosed
doses
doted
doter
dotes
dotty
douce
dough
douma
doura
douse
doves
dowdy
dowel
dower
dowie
downs
downy
dowry
dowse
doyen
dozed
dozer
dozes
drabs
draff
drags
drake
drams
drape
drawl
draws
drays
drear
dregs
drier
dries
drily
drips
droit
droll
drone
drool
droop
drops
dross
drubs
drugs
druid
drums
drupe
druse
dryad
dryer
dryly
duads
duals
ducal
ducat
duchy
ducks
ducky
ducts
duded
dudes
duels
duets
duffs
dukes
dulia
dulls
dully
dulse
dumbo
dumps
dumpy
dunce
dunes
dungs
dunks
dunno
dunny
duomo
duped
duper
dupes
duple
duppy
durra
durst
durum
dusky
dusts
dutch
duvet
dwarf
dweeb
dwell
dwelt
dyads
dyers
dykes
dynes
eagre
eared
earls
earns
eased
easel
eases
eaves
ebbed
ebony
edema
edged
edger
edges
edict
edify
edits
educe
educt
eerie
effed
egads
egest
egged
egger
egret
eider
eidos
eikon
eject
eking
eland
elate
elbow
elder
elegy
elemi
elfin
elide
elope
elude
elute
elver
elves
email
embay
ember
embow
embus
emcee
emend
emery
emirs
emits
emmer
emmet
emoji
emote
enact
enate
endow
endue
enema
ennui
enrol
ensue
envoi
envoy
enzed
eosin
epact
ephah
ephod
ephor
epics
epoch
epode
epoxy
erect
ergot
ernes
erode
erose
erred
eruct
erugo
erupt
esker
ester
estop
ether
ethos
ethyl
etnas
euros
evade
evens
evert
evict
evils
evite
evoke
ewers
exalt
exams
excel
exeat
execs
exert
exile
exine
exits
exons
expat
expel
expos
extol
exude
exult
exurb
eyras
eyrir
fable
facer
faces
facet
facts
faddy
faded
fader
fades
fadge
faena
faffs
fagot
fails
fairs
faked
faker
fakes
fakir
falls
famed
fango
fangs
fanny
fanon
faqir
farad
farci
farcy
fared
farer
fares
farms
farts
fasts
fated
fates
fatly
fatso
fatty
fatwa
faugh
fauna
fauns
fauve
faves
favor
favus
fawns
faxed
faxes
fayer
fayre
fazed
fazes
fears
feast
feats
fecal
feces
fecit
feeds
feels
feeze
feign
feint
felid
fella
fells
felly
felon
felts
femme
femur
fends
fenny
feoff
feral
feria
fermi
ferns
ferny
ferry
fests
fetal
feted
fetid
fetor
fetus
feuar
feuds
feyly
fiats
fiber
fibre
fiche
fichu
ficus
fidge
fiefs
fiend
fiery
fifer
fifes
filar
filch
filer
files
filet
fills
filly
films
filmy
filth
filum
finch
finds
fines
finis
finks
finny
firer
fires
firms
firry
firth
fiscs
fishy
fists
fitch
fitly
fives
fixer
fixes
fjeld
fjord
flack
flags
flail
flair
flake
flaky
flank
flans
flaps
flare
flask
flats
flaws
flawy
flays
fleam
fleas
fleck
fleer
flees
flews
flick
flier
flies
fling
flint
flips
flirt
flite
flits
flock
flocs
floes
flogs
flong
flops
flora
flory
floss
flout
flows
flubs
flues
fluff
fluke
fluky
flume
flump
flung
flunk
fluor
fluty
flyby
flyer
flyte
foals
foams
foamy
focal
foehn
fogey
foggy
foils
foist
folds
folia
folic
folie
folio
folks
folly
fonts
foods
fools
foots
footy
foray
forby
fordo
fords
fores
forge
forgo
forks
forme
forms
forte
forts
fossa
fosse
fouls
fount
fourb
fours
fovea
fowls
foxed
foxes
foyer
frack
frail
franc
fraps
frats
frays
freer
frees
fremd
frena
frets
friar
fries
frigs
frill
frise
frisk
frith
fritz
frize
frizz
frock
frogs
frond
frons
frore
frosh
frost
froth
frump
fryer
fubsy
fucks
fucus
fuels
fugal
fuggy
fugue
fulls
fumed
fumes
funds
fungi
fungo
funks
funky
furan
furls
furor
furze
furzy
fused
fusee
fuses
fusil
fusty
futon
gabby
gable
gadid
gaffe
gaffs
gaily
gains
gaits
galah
galas
galea
gales
galls
galop
gamba
gamed
gamer
games
gamic
gamin
gamma
gammy
gamps
gamut
ganef
gangs
ganja
ganof
gaped
gapes
gappy
garbo
garbs
garth
gases
gasps
gassy
gated
gater
gates
gator
gauds
gaudy
gauge
gaunt
gaurs
gauss
gauze
gauzy
gavel
gawks
gawky
gawps
gayer
gazed
gazer
gazes
geans
gears
gecko
geeks
geeky
geese
geest
gelds
gelid
gemma
gemmy
gemot
genes
genet
genic
genie
genii
genip
genoa
genro
gents
genus
geode
geoid
gerah
germs
germy
gesso
getup
ghats
ghazi
ghees
ghoul
ghyll
gibed
giber
gibes
giddy
gifts
gigot
gigue
gilds
gills
gilts
gimel
gimme
gimps
gimpy
ginny
gipon
girds
girls
girly
giros
girth
girts
gites
giver
gives
gizmo
glade
glads
glair
gland
glans
glare
glary
glaze
gleam
glebe
glede
gleet
glens
glias
glide
glint
glitz
gloam
gloat
globe
globs
gloms
gloom
gloss
glows
gloze
glued
glues
gluey
glume
gluon
gluts
glyph
gnarl
gnash
gnats
gnaws
goads
goals
goats
godly
goers
gofer
golds
golem
golfs
golly
gonad
goner
gongs
gonif
gonna
gonzo
goodo
goods
gooey
goofs
goofy
gooks
goons
goose
goosy
gopak
goral
gored
gores
gorge
gorse
goths
gotta
gouge
gourd
gouty
gowan
gowns
goyim
grabs
grads
graft
grail
grams
grans
grape
grate
gravy
grays
graze
grebe
greet
greys
gride
grids
grift
grill
grime
grimy
grins
gripe
grips
grist
grith
grits
groat
groin
groom
grope
grosz
grots
grout
grove
growl
grows
grubs
gruel
gruff
grume
grump
grunt
guaco
guano
guans
guars
guava
gucks
guild
guile
guise
gulag
gulas
gulch
gules
gulfs
gulls
gully
gulps
gumbo
gumma
gummy
gunge
gungy
gunky
gunny
guppy
gurge
gurus
gushy
gussy
gusto
gusts
gusty
gutsy
gutta
gutty
guyed
guyot
gybed
gybes
gypsy
gyral
gyres
gyron
gyros
gyrus
gyved
gyves
hacek
hacks
hades
hadst
hafiz
hafts
haiku
hails
hairs
hajes
hajji
hakes
hakim
halal
haled
haler
hales
halls
halms
halon
halos
halts
hamal
hames
hammy
hamza
hance
hands
hangs
hanks
hanky
haole
haply
hards
hared
harem
hares
harks
harms
harps
harpy
harry
harts
hasps
haste
hatch
hater
hates
haugh
haulm
hauls
haunt
haven
haver
haves
hawed
hawks
hawse
hayed
hazan
hazed
hazel
hazer
hazes
heads
heady
heals
heaps
hears
heath
heats
heave
heder
hedge
heeds
heels
hefts
hefty
heirs
heist
helix
hells
helms
helot
helps
helve
hemal
hemic
hemin
henge
henna
henry
herbs
herby
herds
heres
heron
hertz
heths
hewed
hewer
hexad
hexed
hexer
hexes
hexyl
hicks
hider
hides
highs
hight
hijab
hiked
hiker
hikes
hills
hilly
hilts
hilum
hinds
hinge
hinny
hints
hippo
hippy
hirer
hires
hitch
hived
hives
hoard
hoars
hoary
hobos
hocks
hocus
hoers
hogan
hoick
hoist
hoked
hokes
hokey
hokku
hokum
holds
holed
holes
holey
holly
homed
homer
homes
homey
homos
honed
honer
hones
honks
honky
honor
hooch
hoods
hooey
hoofs
hooks
hooky
hoons
hoops
hoots
hopes
horah
horal
horas
horme
horns
horny
horst
hosed
hoses
hosta
hosts
hotly
hough
hound
houri
hours
hovel
hover
howdy
howls
hubby
huffs
huffy
huger
hulas
hulks
hulky
hulls
humic
humid
humor
humph
humps
humpy
humus
hunch
hunks
hunky
hunts
hurds
hurls
hurst
hurts
husks
husky
hussy
hutch
hydra
hydro
hyena
hying
hymen
hymns
hyoid
hyped
hyper
hypes
hypha
hypos
hyrax
hyson
iambi
iambs
ichor
icier
icily
icing
icons
ictus
ideas
idled
idler
idles
idols
idyll
igloo
ihram
ileac
ileal
ileum
ileus
iliac
ilium
imago
imams
imbue
imide
imine
immix
impel
inapt
inbox
incus
indie
inept
inert
infix
infra
ingle
ingot
inion
inked
inkle
inlay
inlet
innit
inset
intis
inure
inurn
iodic
ionic
iotas
irade
irked
irons
isles
islet
issei
istle
itchy
items
ivied
ivies
ivory
ixtle
izard
jabot
jacal
jacks
jaded
jades
jaggy
jails
jakes
jalap
jambs
jammy
japan
japed
japer
japes
jatos
jaunt
jawed
jazzy
jeans
jebel
jeeps
jeers
jells
jemmy
jenny
jerid
jerks
jerky
jerry
jests
jetty
jewel
jibed
jibes
jiffs
jiffy
jihad
jilts
jimmy
jingo
jinks
jinni
jived
jiver
jives
jivey
jocko
jocks
joeys
johns
joins
joist
joker
jokes
jokey
jolts
jolty
jorum
joule
joust
jowls
jowly
joyed
jugal
jugum
juicy
jujus
julep
jumbo
jumps
jumpy
junco
junks
junta
jupon
jural
jurat
jurel
juror
jutty
kafir
kaiak
kails
kakis
kalif
kalis
kalpa
kanga
kanji
kanzu
kaons
kaphs
kapok
kappa
kaput
karat
karma
karst
karts
kasha
kauri
kavas
kayak
kayos
kazoo
kebab
kedge
keels
keens
keeps
kelly
kenaf
kendo
kente
kepis
kerbs
kerne
ketch
kevel
khaki
khans
kheda
khoum
kiang
kibes
kicks
kicky
kiddo
kikes
kills
kilns
kilos
kilts
kinas
kinda
kinds
kines
kings
kinin
kinks
kinky
kinos
kiosk
kited
kites
kitty
kiwis
klong
kloof
klutz
knack
knaps
knave
knead
kneed
kneel
knees
knell
knelt
knish
knits
knobs
knoll
knots
knout
knows
knurl
koala
kobos
kohls
koine
kolas
kooks
kooky
kopje
korma
koses
kotos
kraal
kraft
krait
kraut
krill
krone
kroon
kudos
kudus
kudzu
kukri
kulak
kurus
kvass
kyats
kyles
kylie
kylix
labia
labor
laced
lacer
laces
lacks
laded
laden
lades
ladle
lagan
laird
lairs
laity
laker
lakes
lakhs
lamas
lambs
lamed
lamer
lames
lamia
lamps
lanai
lance
lands
lanes
lanky
lapel
lapin
lapse
larch
lards
lardy
lares
largo
larks
larum
larva
lasso
lasts
latch
lated
latex
lathe
lathi
laths
lathy
latke
latte
lauds
lavas
laved
laver
laves
lawns
laxer
laxly
layup
lazar
lazed
lazes
leads
leafs
leafy
leaks
leaky
leans
leaps
leapt
lease
leash
ledge
leech
leeks
leers
leery
lefts
lefty
leges
leggy
legit
leman
lemma
lemme
lemur
lends
lenis
lento
leone
leper
lepta
lethe
letup
levee
lever
levin
lewis
lexis
liana
liard
liars
liber
libra
licit
licks
lidos
liege
liens
lifer
lifts
ligan
liger
liken
liker
likes
lilac
lilly
lilos
lilts
limbo
limbs
limed
limen
limes
limey
limns
limos
limps
lindy
linen
liner
lines
lingo
lings
linin
links
linty
lions
lipid
lippy
lisle
lisps
lists
litas
liter
lithe
litre
liven
lives
livid
livre
llama
llano
loach
loads
loafs
loams
loamy
loans
loath
lobar
lobed
lobes
locks
locos
locum
locus
loden
lodes
loess
lofts
lofty
logan
loges
loggy
logia
login
logon
logos
loins
lolls
lolly
loner
longe
longs
looby
looks
looms
loons
loony
loops
loopy
loots
loped
loper
lopes
loppy
loran
lords
loris
losel
loser
loses
lotas
lotic
lotto
lotus
lough
louis
loupe
lours
loury
louse
louts
loves
lovey
lowed
lowly
luaus
lubed
lubes
lubra
lucid
lucks
lucre
ludic
luffa
luffs
luged
luges
lulls
lulus
lumen
lumps
lumpy
lunar
lunge
lungi
lungs
lupin
lupus
lurch
lured
lures
lurex
lurgy
lurid
lurks
lushy
lusts
lusty
lutes
luxes
lweis
lymph
lynch
lyres
lyses
lysin
lysis
lyssa
lytic
lytta
macaw
maced
maces
macho
macle
macro
madam
madly
mafia
mages
magma
magus
maids
mails
maims
mains
makes
makos
malar
males
malls
malts
malty
mamas
mamba
mambo
mamey
mamma
mammy
manas
manat
maned
manes
manga
mange
mango
mangy
manic
manky
manly
manna
manor
manse
manta
maple
maras
marcs
mares
marge
maria
marka
marks
marls
marly
marsh
marts
maser
masks
mason
massy
masts
mated
mater
mates
matey
matin
matte
matts
matzo
mauls
maund
mauve
maven
mavis
maxed
maxes
maxim
maxis
mayst
mazer
mazes
meals
mealy
means
meany
meats
meaty
mecca
medal
medic
meets
meiny
melds
melic
melon
melts
memes
memos
mends
menus
meows
meres
merle
mesas
mesic
mesne
meson
meted
metes
meths
metic
metis
metre
mewed
mewls
mezzo
miaow
micks
micro
middy
midge
midis
midst
miens
miffs
miffy
miked
mikes
mikva
milch
miler
miles
milfs
milia
milks
milky
mills
milos
milts
mimed
mimer
mimes
mince
minds
miner
mines
mingy
minim
minis
minke
minks
mints
minty
mired
mires
mirin
mirth
mirza
misdo
miser
missy
mists
misty
miter
mites
mitis
mitre
mitts
mixer
mixes
mneme
moans
moats
mocha
mocks
modal
modem
modes
moggy
mogul
mohur
moils
moire
moist
mokes
molal
molar
molas
molds
moldy
moles
molls
molly
molts
mommy
monad
monas
monde
mongo
monks
monte
mooch
moods
moody
mooed
moons
moony
moors
moose
moots
moped
moper
mopes
mopey
moray
morel
mores
morns
morse
mosey
mossy
motel
motes
motet
moths
mothy
motif
motte
moues
mould
moult
mound
mourn
mousy
mover
moves
mowed
mower
moxie
mucin
mucks
mucky
mucor
mucro
mucus
muddy
mudra
muffs
mufti
muggy
mujik
mulch
mulct
mules
muley
mulla
mulls
multi
mumps
munch
muons
mural
murex
murks
murky
murre
mused
muser
muses
mushy
musky
mussy
musth
musts
musty
muted
muter
mutes
mutts
muzak
muzzy
myall
mynah
mynas
myrrh
myths
naans
nabob
nacho
nacre
nadir
naevi
naiad
naifs
nails
naira
naker
nakfa
namer
names
nanas
nance
nancy
nanny
napes
nappe
nappy
narcs
nards
nares
naris
narky
nasal
natal
natch
nates
natty
naval
navar
navel
naves
navvy
nawab
neaps
nears
neath
necks
needs
needy
negro
negus
neigh
nelly
neper
neral
nerds
nerdy
nervy
nests
netty
neume
nevus
newel
newsy
newts
nexus
ngwee
niche
nicks
nidus
niece
niffy
nifty
nigga
nihil
nimbi
nimby
nines
ninja
ninny
ninon
ninth
nipas
nippy
nisei
nisus
niter
nitid
nitre
nitro
nitty
nival
nixed
nixes
nobby
nobly
nocks
nodal
noddy
nodes
nodus
noels
nohow
nomad
nomen
nonce
nones
nonet
nongs
nooks
nooky
noons
noose
noria
norms
nosed
noses
notch
notes
notum
nouns
novae
novas
noway
nubby
nuder
nudes
nudge
nuked
nukes
nulla
nulls
numbs
numen
nutty
nyala
nylon
nymph
oaken
oakum
oared
oases
oasis
oasts
oaten
oaths
obeah
obeli
obese
obeys
obits
objet
oboes
oboli
ocher
ochre
ocker
ocrea
octad
octal
octan
octet
oculi
odder
odeon
odeum
odium
odors
odour
oecus
offal
offed
ogeed
ogham
ogive
ogled
ogler
ogles
ogres
ohmic
oiled
oiler
oinks
okapi
okays
okras
olden
oldie
oleic
olein
oleum
olive
ollas
ology
omasa
omber
ombre
omega
omens
omits
onset
ontic
onyas
oohed
oomph
ootid
oozed
oozes
opahs
opals
opens
opine
oping
opium
orals
orang
orate
orcas
oread
oriel
orlop
ornis
orris
osier
osmic
ottar
otter
ounce
ouphe
ousel
ousts
outdo
outed
outgo
outta
ouzel
ouzos
ovals
ovary
ovate
ovens
overs
overt
ovine
ovoid
ovolo
ovule
owlet
oxbow
oxide
oxime
paced
pacer
paces
pacey
pacha
packs
pacts
paddy
padre
paean
paeon
pagan
pager
pages
pails
pains
pairs
paisa
paled
paler
pales
palls
pally
palms
palmy
palsy
pampa
panda
paned
panes
panga
pangs
panne
pansy
panto
pants
papal
papas
pappy
paras
parch
pared
parer
pares
pareu
parka
parks
parky
parol
parrs
parry
parts
parve
pasha
pashm
pasta
pasts
pasty
paten
pates
paths
patin
patio
patly
patsy
patty
pavan
paved
paves
pavid
pavis
pawed
pawls
pawns
paxes
payee
payer
peach
peags
peaks
peaky
peals
peans
pearl
pears
peart
peaty
pebas
pecan
pecks
peeks
peels
peens
peeps
peers
peeve
pekan
pekes
pekoe
pelts
penal
penis
penna
penne
penni
peons
peony
peppy
perch
perdu
peril
peris
perks
perky
perms
perry
perse
pervs
pesky
pesos
pesto
pests
pesty
petal
peter
petit
pewee
pewit
phage
pheon
phial
phish
phlox
phons
phony
phots
phyla
phyle
picks
picky
picot
picul
piers
piety
piggy
piing
pikas
piked
piker
pikes
pilaf
pilch
piled
pilei
piles
pills
pilly
pimps
pined
pines
piney
pings
pinko
pinks
pinna
pinny
pinta
pinto
pints
pinup
pions
pious
piped
piper
pipes
pipit
pique
pirog
piste
pitas
piths
pithy
piton
pitta
pivot
pixel
pixie
plage
plaid
plait
plank
plans
plash
plasm
plats
platy
playa
plays
plaza
plead
pleas
pleat
plebe
plebs
plena
plica
plied
plier
plies
ploce
plods
plonk
plops
plots
plows
ploys
pluck
plugs
plumb
plume
plump
plums
plumy
plunk
plush
poach
pocks
pocky
poddy
poems
poesy
poets
pogey
pogge
poilu
poise
poked
poker
pokes
pokey
pokie
poled
poler
poles
polio
polis
polka
polls
polyp
polys
pomes
pommy
ponce
poncy
ponds
pones
pongs
pooch
poods
pooed
poofs
poohs
pooka
pools
poons
poops
popes
poppa
poppy
popup
porch
pored
porer
pores
porgy
porky
porno
ports
poser
poses
posit
posse
posts
potto
potty
pouch
poufs
poult
pours
pouts
pouty
poxes
prams
prana
prang
prank
prase
prate
prats
prawn
prays
preen
preps
presa
prese
prexy
preys
prick
pried
prier
pries
prigs
primo
primp
prink
prion
prise
prism
privy
probe
prods
proem
profs
prole
promo
proms
prong
props
prosy
prowl
prows
proxy
prude
prune
psalm
pshaw
psoas
psych
pubes
pubic
pubis
pucka
pucks
pudgy
puffs
puffy
puked
pukes
pukka
pulas
puled
puler
pules
pulls
pulps
pulpy
pumas
pumps
pungs
pungy
punks
punts
pupae
pupal
puppy
puree
purer
purls
purrs
purse
pursy
pushy
pussy
putto
putts
putty
pwned
pygmy
pylon
pyoid
pyres
pyxes
pyxie
pzazz
qibla
qophs
quack
quads
quaff
quail
quake
quaky
quale
qualm
quant
quark
quart
quash
quasi
quass
quays
quean
queer
quell
quern
quids
quiff
quill
quilt
quins
quint
quips
quipu
quire
quirk
quirt
quits
quoin
quoit
quoth
rabbi
racer
races
racks
racon
radii
radix
radon
rafts
ragas
raged
rager
rages
ragga
ragis
raids
rails
rains
rainy
rajah
rajes
raked
raker
rakes
rales
rally
ramen
ramie
ramps
rance
ranch
randy
ranee
rangy
ranks
rants
raped
raper
rapes
rared
rares
rasps
raspy
ratal
ratan
ratel
rater
rates
rathe
ratty
ravel
raven
raver
raves
ravin
rawer
rayon
razed
razee
razes
razoo
reads
reals
reams
reaps
rearm
rears
reata
reave
rebec
rebel
rebid
rebus
rebut
recap
recce
recon
recti
recto
recur
recut
redan
redid
redly
redux
redye
reeds
reedy
reefs
reeks
reeky
reels
reest
reeve
refit
refix
refry
regal
regex
regos
rehab
reify
reins
reive
rejig
relic
remap
remex
remit
remix
renal
rends
renes
renin
rents
reorg
repay
repel
repps
repro
reran
rerun
resat
resew
resin
resit
resow
rests
retch
retie
retro
retry
revel
revet
revue
rewed
rheas
rheum
rhino
rhomb
rhumb
rials
riant
riata
riced
ricer
rices
ricks
rider
rides
ridge
ridgy
riels
rifer
riffs
rifle
rifts
rigor
riled
riles
rille
rills
rimed
rimes
rinds
rings
rinks
rinse
riots
ripen
riper
riser
rises
rishi
risks
rites
ritzy
rived
riven
rives
rivet
riyal
roach
roads
roams
roans
roars
roast
robed
robes
robin
roble
rocks
rocky
rodeo
roger
rogue
roils
roily
roles
rolls
romeo
romps
ronde
rondo
roods
roofs
rooks
rooky
rooms
roomy
roose
roost
roots
roped
roper
ropes
roque
rorts
roses
rosin
rotas
rotls
rotor
rouge
rouse
roust
routs
roved
rover
roves
rowan
rowdy
rowed
rowel
rower
rubel
rubes
ruble
ruche
rucks
rudds
ruddy
ruder
ruffs
rugby
ruing
ruins
rules
rumal
rumba
rumen
rummy
rumor
rumps
runes
rungs
runic
runny
runts
runty
rupee
ruses
rushy
rusks
rusts
ruths
rutty
saber
sabin
sable
sabot
sabra
sabre
sacks
sacra
sades
sadhu
saeta
safes
sagas
sager
sages
saggy
sahib
saiga
sails
saith
saker
sakes
sakis
salad
salep
sales
sally
salmi
salol
salon
salpa
salsa
salts
salty
salve
salvo
samba
sambo
sames
samey
sands
sandy
saner
sangs
sapid
sapor
sappy
saran
sards
sarge
saris
sarky
saros
sasin
sassy
satay
sated
satem
sates
satin
satyr
saucy
sauna
saury
saver
saves
savor
savoy
savvy
sawed
sawer
saxes
sayer
scabs
scads
scald
scalp
scaly
scamp
scams
scans
scant
scape
scarp
scars
scary
scats
scend
scent
schmo
schwa
scion
scoff
scold
scone
scoop
scoot
scorn
scour
scout
scowl
scows
scrag
scram
scree
scrim
scrip
scrod
scrub
scrum
scuba
scudo
scuds
scuff
scull
scums
scups
scurf
scuta
scute
scuts
seals
seams
seamy
sears
seats
sebum
secco
sects
sedan
sedge
sedgy
sedum
seeds
seedy
seeks
seels
seems
seeps
seers
segno
segue
seine
seise
seism
seize
selah
sells
semen
semis
sends
senna
senor
sente
sepal
sepia
sepoy
septa
septs
serai
serer
serfs
serge
serif
serin
serow
serum
servo
setae
setts
setup
sever
sewan
sewed
sewer
sexed
sexes
sexts
shack
shads
shady
shaft
shags
shahs
shako
shale
shalt
shams
shank
shard
shark
shave
shawl
shawm
shays
sheaf
shear
sheds
sheen
sheik
shend
shewn
shews
shied
shier
shies
shill
shims
shins
ships
shire
shirk
shirr
shits
shiva
shive
shivs
shoal
shoat
shoer
shoes
shonk
shool
shoos
shops
shore
shote
shots
shows
showy
shred
shrew
shrub
shrug
shuck
shuns
shunt
shush
shuts
shyer
shyly
sibyl
sicko
sicks
sides
sidle
siege
sieve
sifts
sighs
sigil
signs
sikas
silds
silks
silky
sills
silos
silts
silty
silva
simar
simba
sines
sinew
singe
sings
sinks
sinus
sired
siren
sires
sisal
sises
sissy
sitar
sited
sites
situs
sixes
sizar
sizer
sizes
skald
skate
skean
skeet
skegs
skein
skelp
skeps
skews
skids
skied
skier
skies
skiff
skimp
skims
skink
skins
skint
skips
skirl
skirr
skite
skits
skive
skoal
skosh
skuas
skulk
skunk
slabs
slack
slags
slain
slake
slams
slant
slaps
slate
slats
slaty
slays
sleds
sleek
sleet
slews
slick
slier
slime
slims
slimy
sling
slink
slips
slits
slobs
sloes
slogs
sloop
slops
slosh
sloth
slots
slows
slubs
slued
slues
sluff
slugs
slump
slums
slung
slunk
slurp
slurs
slush
sluts
slyer
slyly
slype
smack
smalt
smarm
smaze
smear
smelt
smews
smirk
smite
smock
smogs
smoko
smoky
smolt
smote
smuts
snafu
snags
snake
snaky
snaps
snare
snarl
snath
sneck
sneer
snick
snide
snipe
snips
snits
snobs
snogs
snood
snook
snoop
snoot
snore
snort
snots
snout
snows
snowy
snubs
snuff
snugs
soaks
soaps
soapy
soars
soave
socks
socle
sodas
sofar
sofas
softa
softy
soggy
soils
solan
soldo
soled
soles
solon
solos
solus
somas
sonar
sonde
sones
songs
sonic
sonly
sonny
sooks
sooky
sooth
sooty
sopor
soppy
sorbs
sorer
sores
sorgo
sorta
sorts
sorus
sough
souks
souls
soups
soupy
sours
souse
sowed
sower
spade
spahi
spake
spall
spams
spang
spank
spans
spark
spars
spasm
spate
spats
spawn
spays
spear
speck
specs
spelt
speos
sperm
spews
spica
spice
spics
spicy
spied
spiel
spier
spies
spiff
spiky
spile
spilt
spine
spins
spiny
spire
spiry
spits
spitz
spivs
splat
splay
spook
spoon
spoor
spore
spots
sprag
sprat
spree
sprig
sprit
sprog
sprue
spuds
spued
spues
spume
spumy
spunk
spurn
spurs
spurt
sputa
squab
squat
squaw
squib
squid
sruti
stabs
stags
stagy
staid
stain
stalk
stane
stang
stank
staph
stars
stash
stats
stave
stays
stead
steak
steed
stein
stela
stele
stems
steno
stent
steps
stere
stern
stets
stews
stich
sties
stile
stilt
sting
stink
stint
stipe
stirk
stirs
stoat
stoic
stoke
stoma
stomp
stony
stook
stool
stoop
stope
stops
stork
stoss
stoup
stour
stout
stove
stows
strap
stree
strep
strew
stria
strop
strow
stroy
strum
strut
stubs
studs
stull
stump
stung
stunk
stuns
stupa
stupe
styli
suave
sucks
sucre
sudor
sudsy
suede
suety
suint
suits
sulci
sulfa
sulks
sulky
sully
sumac
summa
sumps
sunup
supra
surah
sural
suras
surds
surer
surfs
surge
surgy
surly
surra
sushi
sutra
swabs
swage
swags
swain
swale
swami
swank
swans
swaps
sward
swarm
swart
swash
swath
swats
sways
swede
swell
swift
swigs
swill
swims
swine
swink
swipe
swirl
swish
swizz
swoon
swoop
swots
swung
sycee
sylph
syncs
synod
synth
syrup
tabby
tabes
tabla
taboo
tabor
tacet
tache
tacit
tacks
tacky
tacos
taels
taffy
tafia
taiga
tails
taint
takas
takes
takin
talas
taler
tales
talks
talky
tally
talon
taluk
talus
tamed
tamer
tames
tamis
tammy
tamps
tango
tangs
tangy
tanka
tanks
tansy
tanto
tapas
taped
taper
tapes
tapir
tapis
tardy
tared
tares
targe
tarns
taros
tarot
tarps
tarry
tarsi
tarts
tarty
taser
tasks
tasse
tasty
tater
tatty
taunt
taupe
tawny
taxed
taxer
taxes
taxis
taxon
tayra
tazza
teaks
teals
teams
tears
teary
tease
teats
techs
techy
teddy
teems
teens
teeny
telex
telic
tells
telly
tempo
temps
tench
tends
tenet
tenge
tenia
tenno
tenon
tenor
tents
tepee
tepid
terce
terms
terns
terra
terry
tesla
testa
tests
testy
teths
tetra
texts
thane
thaws
thebe
theca
thees
thegn
theta
thews
thewy
thigh
thill
thine
thins
thiol
thole
thong
thorn
thorp
thous
throb
throe
thrum
thuds
thugs
thuja
thump
thuya
thyme
tiara
tibia
tical
ticks
tidal
tided
tides
tiers
tiffs
tigon
tilde
tiled
tiler
tiles
tills
tilth
tilts
times
timid
tinea
tined
tines
tinge
tings
tinny
tints
tipsy
tires
titan
titch
titer
tithe
titis
titre
titty
tizzy
toads
toady
toddy
toeas
toffs
togas
toile
toils
tokay
toked
tokes
tolan
tolar
tolls
tolly
tolus
tolyl
tombs
tomes
tonal
toned
toner
tones
tonga
tongs
tonic
tonne
tonus
tools
toots
topaz
toped
topee
toper
topes
toque
torch
torii
torrs
torse
torsk
torso
torte
torts
torus
toted
totem
toter
totes
tours
touts
towed
towel
towns
toxic
toxin
toyed
tract
trait
tramp
trams
traps
trass
trave
trawl
trays
treed
treen
trees
treks
tress
trews
treys
triad
trice
trier
tries
trike
trill
trims
trine
trios
tripe
trips
trite
troat
troll
tromp
trona
trope
troth
trots
trout
trove
trows
troys
truce
trued
truer
trues
trugs
trull
trump
truss
tryma
tryst
tsars
tubal
tubas
tubby
tubed
tuber
tubes
tucks
tufts
tufty
tulip
tulle
tumid
tummy
tumor
tunas
tuner
tunes
tunic
tunny
tuple
tuque
turbo
turds
turfs
turfy
turns
turps
tushy
tusks
tutti
tutty
tutus
tuxes
twain
twang
twats
tweak
tweed
tween
tweet
twerk
twerp
twigs
twill
twine
twink
twins
twirl
twits
twixt
tykes
typal
types
typos
tyres
tyros
udder
uhlan
ukase
ulcer
ulema
ulnae
ulnar
ultra
umbel
umber
umbra
umiak
umped
unapt
unarm
unbar
unbid
uncap
uncut
undue
unfed
unfit
unfix
units
unjam
unlay
unlit
unman
unmet
unpeg
unpen
unpin
unrig
unsay
unsex
untie
unwed
unwon
unzip
upend
upped
uredo
urger
urges
urial
urine
users
usher
usurp
usury
uteri
utile
uveas
uvula
vagal
vagus
vales
valet
valor
valse
vamps
vampy
vanda
vanes
vaped
vapes
vapid
vapor
varas
varia
varix
varus
varve
vases
vasts
vasty
vatic
vault
vaunt
vedic
veeps
veers
veery
vegan
veges
veils
veins
veiny
velar
velds
velum
venae
venal
vends
venge
venin
venom
vents
verbs
verey
verge
versa
verso
verst
vertu
verve
vesta
vests
vetch
veter
vexed
vexes
vials
viand
vibes
viced
vices
views
viewy
vigil
vigor
viler
villa
villi
vimen
vines
vinic
viola
viols
viper
viral
vireo
virga
virtu
visas
vised
vises
visor
vista
vitae
vitta
vivas
vivid
vixen
vodka
vogue
voids
voile
volar
voles
volts
volva
vomer
votes
vouge
vowed
vower
vulva
vying
wacke
wacko
wacks
wacky
wader
wades
wadge
wadis
wafer
wafts
waged
wager
wages
wagon
wahoo
waifs
wails
wains
waist
waits
waive
waken
wakes
waled
wales
walks
walls
wally
waltz
wands
waned
wanes
wanks
wanly
wanna
wants
wards
wares
warms
warns
warps
warts
warty
washy
wasps
watts
waver
waves
waxed
waxen
waxes
wazoo
weald
weals
weans
wears
weave
webby
weber
wedge
weeds
weedy
weeks
weens
weeny
weeps
weepy
weest
wefts
weirs
wekas
welds
wells
welly
welsh
welts
wench
wends
wersh
wetly
whack
whams
whaps
wharf
whats
wheal
wheat
wheen
whelk
whelm
whelp
whens
whets
whiff
whims
whine
whins
whiny
whips
whipt
whirl
whirr
whirs
whish
whisk
whist
whits
whity
whizz
whomp
whops
whore
whorl
whoso
whups
wicks
widen
wides
widow
wield
wight
wikis
wilds
wiled
wiles
wills
willy
wilts
wimps
wimpy
wince
winch
winds
windy
wined
wines
wings
winks
winos
winze
wiper
wipes
wirer
wires
wirra
wised
wisen
wises
wisps
wispy
withe
withy
wived
wives
wizen
woald
wodge
wolds
wolfs
wombs
wonks
wonky
woods
woody
wooed
wooer
woofs
wools
woops
woozy
words
wordy
works
worms
wormy
woven
wowed
wrack
wraps
wreak
wrens
wrest
wring
writs
wroth
wrung
wryer
wryly
wurst
wussy
xebec
xenia
xenon
xeric
xerox
xylem
xylol
yabby
yacht
yahoo
yakka
yamen
yanks
yapok
yapon
yappy
yards
yarns
yawed
yawls
yawns
yawps
yeahs
yeans
yearn
years
yeast
yeggs
yells
yelps
yenta
yeses
yetis
yikes
yobbo
yodel
yodle
yogic
yogis
yoked
yokel
yokes
yolks
yonks
yours
youse
yowls
yucca
yucky
yukky
yulan
yummy
yurts
zacks
zaire
zamia
zappy
zarfs
zayin
zazen
zebec
zebra
zebus
zeros
zests
zesty
zetas
zibet
zilch
zincs
zines
zings
zingy
zippy
zitis
zloty
zonal
zoned
zones
zooid
zooms
zoril`;
